import { useState } from "react";
import { useGetTenantUsuarios } from "core/features/tenants/hooks";
import useFiltro from "infra/helpers/useFiltro";
import UsuariosTable from "./components/UsuariosTable";
import ModalCadastroEditar from "./components/ModalCadastroEditar";
import { TipoTenantEnum } from "core/resources/enums/tenant";
import { Col, Row } from "antd";
import PageHeader from "components/Page/PageHeader";
import { Box } from "@chakra-ui/layout";
import { useInvalidateQuery } from "infra/packages/react-query";

interface TenantUsuarioProps {
  tenantId: string;
  tipoTenantId: TipoTenantEnum;
}

function TenantUsuarios({ tenantId, tipoTenantId }: TenantUsuarioProps) {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [userEditId, setUserEditId] = useState<string | undefined>();
  const { filtro, onChangeFiltro } = useFiltro();
  const { doInvalidateQueryWithStringKey } = useInvalidateQuery();

  const { data, isLoading, isFetching, refetch } = useGetTenantUsuarios({
    tenantId,
    ...filtro,
  });

  const _isLoading = isLoading || isFetching;

  const handleModalClose = () => {
    setIsOpenModal(false);
    setUserEditId(undefined);
  };

  const handleSuccess = async () => {
    refetch();
    setIsOpenModal(false);
    setUserEditId(undefined);
    doInvalidateQueryWithStringKey("/v1/tenants/passos-cadastro");
  };

  const isCondominio = tipoTenantId === TipoTenantEnum.Condominio;

  return (
    <>
      <PageHeader
        title={isCondominio ? "Responsáveis Legais" : "Usuários"}
        titleButton="Cadastrar Novo"
        onClick={() => setIsOpenModal(true)}
      />

      {isOpenModal || !!userEditId ? (
        <ModalCadastroEditar
          tipoTenantId={tipoTenantId}
          isOpen={isOpenModal || !!userEditId}
          onClose={handleModalClose}
          onSaved={handleSuccess}
          usuarioId={userEditId}
          tenantId={tenantId}
        />
      ) : null}

      <Row gutter={32}>
        <Col sm={24}>
          {/* <DashboardUsers /> */}

          <Box>
            <UsuariosTable
              searchValue={filtro.search || ""}
              onSearch={(q) => onChangeFiltro("search", q)}
              data={data}
              isLoading={_isLoading}
              onPaginate={(p) => onChangeFiltro("page", p)}
              onDeleted={() => {
                refetch();
                doInvalidateQueryWithStringKey("/v1/tenants/passos-cadastro");
              }}
              tenantId={tenantId}
              onEdit={(data) => setUserEditId(data.id)}
              onClickRow={(v: any) => setUserEditId(v.id)}
            />
          </Box>
        </Col>

        {/* {!hideSidebar ? (
          <Col sm={7}>
            <Sidebar img={usersSvg}>
              {user ? (
                <UserDetails
                  onEdit={() => {
                    setUserEditId(user.id);
                  }}
                  user={user}
                />
              ) : null}
            </Sidebar>
          </Col>
        ) : null} */}
      </Row>
    </>
  );
}

export default TenantUsuarios;
